import styled from "styled-components";

export const Container = styled.div<{ positive: boolean }>`
  padding: 10px 16px;
  border-radius: 8px;
  background: ${(props) =>
    props.positive ? "rgba(38, 190, 81, 0.20)" : "rgba(237, 0, 0, 0.1)"};
  height: 44px;
  display: flex;
  justify-content: end;
  align-items: center;
  gap: 10px;

  color: #595959;
  font-family: Mulish;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px;
`;

export const WrapperImg = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
